import "@dxos/node-std/globals";

// src/packlets/diagnostics/diagnostics-broadcast.ts
var createCollectDiagnosticsBroadcastSender = () => {
  return {
    broadcastDiagnosticsRequest: async () => void 0
  };
};
var createCollectDiagnosticsBroadcastHandler = (_) => {
  return {
    start: () => {
    },
    stop: () => {
    }
  };
};

export {
  createCollectDiagnosticsBroadcastSender,
  createCollectDiagnosticsBroadcastHandler
};
//# sourceMappingURL=chunk-XJRPB3GA.mjs.map
